import { useLanguage } from "@/lib/LanguageContext";
import { useReveal } from "@/lib/useReveal";

const builds = [
  { id: 1, span: "md:col-span-7" },
  { id: 2, span: "md:col-span-5" },
  { id: 3, span: "md:col-span-5" },
  { id: 4, span: "md:col-span-7" },
];

export default function Portfolio() {
  const { t } = useLanguage();
  const ref = useReveal();

  return (
    <section
      id="portfolio"
      data-testid="portfolio-section"
      className="px-6 sm:px-12 lg:px-24 py-24 sm:py-32"
    >
      <div ref={ref} className="reveal flex flex-col lg:flex-row lg:items-end justify-between gap-8 mb-16">
        <div className="max-w-2xl">
          <p className="text-xs font-bold uppercase tracking-[0.3em] text-[#D97736] mb-4">
            {t.portfolio.overline}
          </p>
          <h2 className="font-display font-bold text-white text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.05] mb-4">
            {t.portfolio.title}
          </h2>
          <p className="text-[#A0AAB2] text-lg leading-relaxed">
            {t.portfolio.subtitle}
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-12 gap-5">
        {builds.map((b, i) => (
          <div
            key={b.id}
            data-testid={`portfolio-item-${i}`}
            className={`group relative col-span-1 ${b.span} overflow-hidden bg-[#14161A] border border-white/5 hover:border-white/15 transition-all duration-500`}
          >
            <div className="aspect-[4/3] flex items-center justify-center relative">
              <span
                className="font-display font-black text-white/5 leading-none select-none"
                style={{ fontSize: "clamp(6rem, 16vw, 14rem)" }}
              >
                {String(b.id).padStart(2, "0")}
              </span>
              <span className="absolute bottom-6 left-6 text-xs font-bold uppercase tracking-[0.3em] text-[#D97736]">
                Coming soon
              </span>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
